/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReadUserDto } from './readUserDto';


export interface ReadAppointmentConfigDto { 
    /**
     * The unique identifier
     */
    id: string;
    /**
     * The kind of appointment configuration
     */
    kind: string;
    /**
     * The value associated with the configuration
     */
    value: number;
    /**
     * The unit of time for the configuration
     */
    unit: ReadAppointmentConfigDto.UnitEnum;
    /**
     * The user who created the configuration
     */
    createdBy: ReadUserDto;
    /**
     * multiple
     */
    multiple: boolean;
    /**
     * with fisical address
     */
    withAddress: boolean;
    /**
     * with notification
     */
    withNotification: boolean;
    /**
     * creation date
     */
    createdAt: string;
    /**
     * update date
     */
    updatedAt: string;
}
export namespace ReadAppointmentConfigDto {
    export const UnitEnum = {
        Seconds: 'seconds',
        Minutes: 'minutes',
        Hours: 'hours',
        Days: 'days',
        Weeks: 'weeks',
        Months: 'months',
        Years: 'years'
    } as const;
    export type UnitEnum = typeof UnitEnum[keyof typeof UnitEnum];
}


